import { LocationSearchAddress } from './LocationSearchAddress';
import { LocationSearchPredictionAddressesList } from './LocationSearchPredictionAddressesList';

export const Location = {
  SearchAddress: LocationSearchAddress,
  SearchPredictionAddressesList: LocationSearchPredictionAddressesList,
};
